import React from 'react';
import img from '../assets/img/dr-zaid.png';
import { LazyLoadImage } from "react-lazy-load-image-component";
import { motion } from 'framer-motion';
import "react-lazy-load-image-component/src/effects/blur.css";

function About({ t, language }) {
    const isMobile = window.innerWidth < 768;
    const isRTL = language === 'ar' || language === 'ku';


    return (
        <div className={`h-auto lg:h-[90vh] flex justify-center bg-[#6A9C89] ${isRTL ? 'flex-row-reverse' : ''}`}>
            <motion.div
                className='flex flex-col md:flex-row md:justify-between m-10 md:m-20 rounded-xl shadow-lg w-full md:w-[900px] p-5 bg-[#ffffffea] md:h-[350px]'
                initial={{ opacity: 0, x: isRTL ? (isMobile ? 100 : 300) : (isMobile ? -100 : -300) }}
                whileInView={{ opacity: 1, x: 0 }}
                exit={{ opacity: 0, x: isRTL ? -300 : 300 }}
                transition={{ duration: isMobile ? 1.5 : 2 }}
                viewport={{ once: false, amount: 0.5 }}
            >
                <div className={`flex justify-center ${isRTL ? 'md:justify-end' : 'md:justify-start'}`}>
                    <LazyLoadImage
                        src={img}
                        effect="blur"
                        alt='Dr. Zaid Photo'
                        className='w-[100%] md:w-[600px] p-5 object-cover h-[100%]'
                    />
                </div>

                <div className={`text-base mt-5 mr-5 md:mt-20  md:m-2 w-[100%] ${isRTL ? 'text-end' : 'text-start'}`}>
                    <h1 className='text-[#16423c] text-xl md:text-2xl '>
                        {t('aboutName')}
                    </h1>
                    <p className='md:text-xl mt-5'>
                        {t('aboutDescripstion')}
                    </p>
                </div>

                {/* <div className='hidden md:block md:flex justify-center md:justify-end'>
                    <LazyLoadImage
                        src={img}
                        effect="blur"
                        alt='Dr. Zaid Photo'
                        className='w-[100%] md:w-[600px] p-5 object-cover h-[100%]'
                    />
                </div> */}

            </motion.div>
        </div>
    );
}

export default About;
